// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1N5-pjcQLBNjsP {\n  height: auto;\n}\n._1N5-pjcQLBNjsP span[aria-label=\"StarIcon\"] {\n  color: #F2D600;\n}\n._1N5-pjcQLBNjsP:active span[aria-label=\"StarIcon\"],\n._1N5-pjcQLBNjsP:focus span[aria-label=\"StarIcon\"],\n._1N5-pjcQLBNjsP:hover span[aria-label=\"StarIcon\"] {\n  color: #172B4D;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"yellowStar": "_1N5-pjcQLBNjsP"
};
export default ___CSS_LOADER_EXPORT___;
